import React from 'react';
import SidebarNavItem from 'components/sidebar/SidebarNavItem';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';

export default function ScanLeftSideBar() {
  return <>
    <SidebarNavItem to="/scan" label="Scan" Icon={ImageSearchIcon} matchExtact/>
  </>
}